import { useState, useMemo } from "react";
import { useAccount, useBalance, useContractWrite } from "wagmi";
import { useReadContract } from "wagmi";
import { ethers } from "ethers";
import { Card, AppBar, Tabs, Tab, Divider, IconButton, Tooltip, Modal, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VuiBox from "components/VuiBox";
import VuiBadge from "components/VuiBadge";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import contractABI from "../../assets/contractABI.json";
import Table from "examples/Tables/Table";
import { config } from "index";
import VuiInput from "components/VuiInput";
import { useWallet } from "WalletProvider";
import { writeContract } from "@wagmi/core";
import { Bounce, toast } from "react-toastify";
import axios from "axios";

function MarketActivitySection({
  marketId,
  onWithdraw,
  refreshData,
  selectedMarket,
  motherMarket,
  childMarket,
}) {
  const [transactionsTab, setTransactionsTab] = useState(0);
  const { address } = useAccount();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [withdrawType, setWithdrawType] = useState("");
  const { wallet, selectedChain } = useWallet();


  const userMotherBalance = useBalance({
    address: wallet.address,
    token: motherMarket?.baseToken?.address, 
  })
  console.log(userMotherBalance)

  const userChildBalance = useBalance({
    address: wallet.address,
    token: childMarket?.baseToken?.address, 
  })

  // Open modal with appropriate type
  const openWithdrawModal = (type) => {
    setWithdrawType(type);


    setIsModalOpen(true);
  };

  // Handle input change
  const handleAmountChange = (e) => {
    setWithdrawAmount(e.target.value);
  };

  // Fetch all market transactions
  const {
    data: rawTxData,
    isLoading: isLoadingTx,
    isError: isErrorTx,
  } = useReadContract({
    abi: contractABI,
    address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
    functionName: "getAllTransactionsByMarket",
    args: [BigInt(marketId)],
  });

  // Fetch user deposits
  const {
    data: userDeposits,
    isLoading: isLoadingDeposits,
    isError: isErrorDeposits,
  } = useReadContract({
    abi: contractABI,
    address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
    functionName: "getAllUserDeposits",
    args: [address, BigInt(marketId)],
    enabled: !!address,
  });
  


  // Market transactions columns
  const txColumns = [
    { name: "txType", align: "left" },
    { name: "user", align: "left" },
    { name: "token", align: "center" },
    { name: "amount", align: "center" },
    { name: "timestamp", align: "right" },
  ];

  // Format market transactions for the table
  const txRows = useMemo(() => {
    if (!rawTxData) return [];

    // Sort transactions by timestamp (newest first)
    const sortedTx = [...rawTxData].sort((a, b) => Number(b.timestamp) - Number(a.timestamp));

    return sortedTx.map((tx) => ({
      txType: (
        <VuiBox display="flex" alignItems="center">
          {tx.txType === 0 ? (
            <ArrowDownwardIcon sx={{ color: "#17ad37", mr: 1 }} />
          ) : (
            <ArrowUpwardIcon sx={{ color: "#fb8c00", mr: 1 }} />
          )}
          <VuiTypography variant="button" color="white" fontWeight="medium">
            {tx.txType === 0 ? "Deposit" : "Withdraw"}
          </VuiTypography>
        </VuiBox>
      ),
      user: (
        <VuiBox>
          <VuiTypography variant="button" color="white" fontWeight="medium">
            {tx.user.slice(0, 6) + "..." + tx.user.slice(-4)}
          </VuiTypography>
          {tx.user.toLowerCase() === address?.toLowerCase() && (
            <VuiTypography variant="caption" color="success" fontWeight="medium" ml={1}>
              (You)
            </VuiTypography>
          )}
        </VuiBox>
      ),
      token: (
        <VuiBox display="flex" justifyContent="center">
          <VuiBadge
            variant="contained"
            color={tx.isMotherToken ? "info" : "success"}
            size="xs"
            badgeContent={
              tx.isMotherToken
                ? motherMarket?.baseToken?.name?.charAt(0) || "M"
                : childMarket?.baseToken?.name?.charAt(0) || "C"
            }
            circular
            container
          />
        </VuiBox>
      ),
      amount: (
        <VuiTypography variant="button" color="white" fontWeight="medium">
          {parseFloat(ethers.utils.formatUnits(tx.amount, 18)).toFixed(2)}
        </VuiTypography>
      ),
      timestamp: (
        <VuiBox display="flex" alignItems="center" justifyContent="flex-end">
          <AccessTimeIcon fontSize="small" sx={{ mr: 0.5, opacity: 0.7 }} />
          <VuiTypography variant="caption" color="text">
            {new Date(Number(tx.timestamp) * 1000).toLocaleString()}
          </VuiTypography>
        </VuiBox>
      ),
    }));
  }, [rawTxData, address]);

  // Process the withdrawal
  const processWithdrawal = async () => {
 

    const maxAmount =
      withdrawType === "mother" ? userDeposits?.motherDeposit : userDeposits?.childDeposit;

    if (parseFloat(withdrawAmount) > maxAmount) {
      console.error(`You can't withdraw more than your deposit (${maxAmount})`);
      return;
    }

    try {
      setIsLoading(true);
      if(withdrawType === "mother"){
        
        var parsedAmount = ethers.utils.parseUnits(withdrawAmount,selectedMarket?.motherTokenDecimal === 0n ? 18 : selectedMarket?.motherTokenDecimal);
      }else{
        var parsedAmount = ethers.utils.parseUnits(withdrawAmount,selectedMarket?.motherTokenDecimal === 0n ? 18 : selectedMarket?.motherTokenDecimal);
      }
      // const parsedAmount = ethers.utils.parseEther(withdrawAmount);
      const isMotherToken = withdrawType === "mother";
      console.log("WITHDRAWING")

      // Using writeContract as per your example
      const withdraw  = await writeContract(config, {
        abi: contractABI,
        address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
        functionName: "withdraw",
        args: [BigInt(marketId),parsedAmount, isMotherToken],
      });

      console.log("complete",withdraw)
      toast.success('🦄 Tokens withdrawn successfully!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
      if (!withdrawAmount) {
        console.error("Please enter a valid amount");
        return;
      }
   
      // toast.success(`${withdrawType === 'mother' ? 'Mother' : 'Child'} tokens withdrawn successfully`);
      // refetchUserDeposits();
      setIsModalOpen(false);
    } catch (error) {
      console.error(`Error withdrawing ${withdrawType} tokens:`, error);
      toast.error('Tokens withdrawn Error!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
      if (!withdrawAmount) {
        console.error("Please enter a valid amount");
        return;
      }
      // toast.error(`Failed to withdraw ${withdrawType} tokens`);
    } finally {
      setIsLoading(false);
    }
  };

  // Calculate if user has any deposits
  const hasDeposits = useMemo(() => {
    if (!userDeposits) return false;
    return userDeposits.motherDeposit > 0 || userDeposits.childDeposit > 0;
  }, [userDeposits]);

  const handleClaim = async () => {
    try {
      setIsLoading(true);

      const updatePoints = async (marketid) => {
        try {
          const response = await axios.get(
            `https://rafiki-launchpad.devligence.com/points/reward/${marketid}/${wallet.address}`
          );
          
          
        } catch (error) {
          console.error("Error fetching user points", error);
        }
      };

    const resp = await updatePoints(Number(marketId));
    if(resp.data.success){
      const message = await writeContract(config, {
        abi: contractABI,
        address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
        functionName: "claimReward",
        args: [wallet?.address,BigInt(marketId)],
      });
      console.log("Clain message")
      console.log(message)
      toast.success("🦄 Rewards Claimed successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }

       
      setIsLoading(false);

    } catch (error) {
      toast.error("🦄 Claiming Failed, Kindly try later!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setIsLoading(false);

    }

  }

  return (
    <Card
      sx={{
        mt: 3,
        background: "rgba(19, 21, 34, 0.9)",
        borderRadius: "15px",
        overflow: "hidden",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
      }}
    >
      <AppBar position="static" sx={{ background: "transparent", boxShadow: "none" }}>
        <VuiBox display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
          <Tabs
            value={transactionsTab}
            onChange={(e, newVal) => setTransactionsTab(newVal)}
            sx={{
              background: "transparent",
              "& .MuiTabs-indicator": {
                backgroundColor: transactionsTab === 0 ? "#1976d2" : "#2e7d32",
                height: "3px",
              },
            }}
          >
            <Tab
              label="My Positions"
              sx={{
                color: transactionsTab === 0 ? "#fff" : "rgba(255, 255, 255, 0.7)",
                fontWeight: transactionsTab === 0 ? "bold" : "normal",
              }}
            />
            <Tab
              label="Market Transactions"
              sx={{
                color: transactionsTab === 1 ? "#fff" : "rgba(255, 255, 255, 0.7)",
                fontWeight: transactionsTab === 1 ? "bold" : "normal",
              }}
            />
          </Tabs>

          <Tooltip title="Refresh data">
            <IconButton
              onClick={refreshData}
              size="small"
              sx={{ color: "rgba(255, 255, 255, 0.7)" }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </VuiBox>
      </AppBar>

      <Divider light sx={{ opacity: 0.2 }} />

      <VuiBox p={2}>
        {transactionsTab === 0 ? (
          <>
            {!address ? (
              <VuiBox
                textAlign="center"
                py={5}
                sx={{
                  background: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                }}
              >
                <VuiTypography variant="h6" color="text" fontWeight="regular">
                  Connect your wallet to view your positions
                </VuiTypography>
              </VuiBox>
            ) : isLoadingDeposits ? (
              <VuiBox textAlign="center" py={5}>
                <VuiTypography variant="button" color="text">
                  Loading your positions...
                </VuiTypography>
              </VuiBox>
            ) : !hasDeposits ? (
              <VuiBox
                textAlign="center"
                py={5}
                sx={{
                  background: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                }}
              >
                <VuiTypography variant="h6" color="text" fontWeight="regular">
                  You don't have any positions in this market
                </VuiTypography>
                <VuiTypography variant="caption" color="text" mt={1}>
                  Deposit tokens to participate
                </VuiTypography>
              </VuiBox>
            ) : (
              <VuiBox>
                {/* Mother Token Deposit Card */}
                <VuiBox display="flex" justifyContent="right" alignItems="center" mb={2}>
                
                  <VuiButton
                    color="success"
                    size="small"
                    onClick={handleClaim}
                    disabled={isLoading || !userDeposits?.claimableFee || Number(userDeposits.claimableFee) <= 0 || selectedMarket?.status < 2}
                    sx={{
                      minWidth: "100px",

                      py: 0.5,
                      "&:hover": {
                        boxShadow: "0 0 10px rgba(23, 173, 55, 0.3)",
                      },
                    }}
                  >
                    Claim {parseFloat(ethers.utils.formatUnits(userDeposits?.claimableFee,selectedMarket?.motherTokenDecimal === 0n ? 18 : selectedMarket?.motherTokenDecimal)).toFixed(2)} Rewards
                  </VuiButton>
                </VuiBox>
                {userDeposits?.motherDeposit > 0 && (
                  <VuiBox
                    mb={2}
                    sx={{
                      background: "rgba(33, 82, 255, 0.1)",
                      borderRadius: "12px",
                      border: "1px solid rgba(33, 82, 255, 0.3)",
                      p: 2,
                    }}
                  >
                    <VuiBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={2}
                    >
                      <VuiBox display="flex" alignItems="center">
                        <VuiBadge
                          variant="contained"
                          color="info"
                          size="sm"
                          badgeContent="M"
                          circular
                          container
                        />
                        <VuiTypography variant="button" color="white" fontWeight="medium" ml={2}>
                          Mother Token
                        </VuiTypography>
                      </VuiBox>
                      <VuiButton
                        color="info"
                        size="small"
                        disabled={selectedMarket?.status > 0}
                        onClick={() => openWithdrawModal("mother")}
                        sx={{
                          minWidth: "100px",
                          py: 0.5,
                          "&:hover": {
                            boxShadow: "0 0 10px rgba(33, 82, 255, 0.3)",
                          },
                        }}
                      >
                        Withdraw
                      </VuiButton>
                    </VuiBox>

                    <VuiBox display="flex" justifyContent="space-between" mb={0.5}>
                      <VuiTypography variant="caption" color="text">
                        Amount
                      </VuiTypography>
                      <VuiTypography variant="button" color="white" fontWeight="bold">
                        {ethers.utils.formatUnits(userDeposits.motherDeposit, 18)}{" "}
                        {motherMarket?.baseToken?.symbol}
                      </VuiTypography>
                    </VuiBox>

                    <VuiBox display="flex" justifyContent="space-between">
                      <VuiTypography variant="caption" color="text">
                        Value
                      </VuiTypography>
                      <VuiTypography variant="button" color="white">
                        $
                        {(
                          parseFloat(ethers.utils.formatUnits(userDeposits.motherDeposit, 18)) *
                          (motherMarket?.priceUsd || 0)
                        ).toFixed(2)}
                      </VuiTypography>
                    </VuiBox>
                  </VuiBox>
                )}

                {/* Child Token Deposit Card */}
                {userDeposits?.childDeposit > 0 && (
                  <VuiBox
                    mb={2}
                    sx={{
                      background: "rgba(23, 173, 55, 0.1)",
                      borderRadius: "12px",
                      border: "1px solid rgba(23, 173, 55, 0.3)",
                      p: 2,
                    }}
                  >
                    <VuiBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={2}
                    >
                      <VuiBox display="flex" alignItems="center">
                        <VuiBadge
                          variant="contained"
                          color="success"
                          size="sm"
                          badgeContent="C"
                          circular
                          container
                        />
                        <VuiTypography variant="button" color="white" fontWeight="medium" ml={2}>
                          Child Token
                        </VuiTypography>
                      </VuiBox>
                      <VuiButton
                        color="success"
                        size="small"
                        disabled={selectedMarket?.status >0}
                        onClick={() => openWithdrawModal("child")}
                        sx={{
                          minWidth: "100px",
                          py: 0.5,
                          "&:hover": {
                            boxShadow: "0 0 10px rgba(23, 173, 55, 0.3)",
                          },
                        }}
                      >
                        Withdraw
                      </VuiButton>
                    </VuiBox>

                    <VuiBox display="flex" justifyContent="space-between" mb={0.5}>
                      <VuiTypography variant="caption" color="text">
                        Amount
                      </VuiTypography>
                      <VuiTypography variant="button" color="white" fontWeight="bold">
                        {ethers.utils.formatUnits(userDeposits.childDeposit, 18)}{" "}
                        {childMarket?.baseToken?.symbol}
                      </VuiTypography>
                    </VuiBox>

                    <VuiBox display="flex" justifyContent="space-between">
                      <VuiTypography variant="caption" color="text">
                        Value
                      </VuiTypography>
                      <VuiTypography variant="button" color="white">
                        $
                        {(
                          parseFloat(ethers.utils.formatUnits(userDeposits.childDeposit, 18)) *
                          (childMarket?.priceUsd || 0)
                        ).toFixed(2)}
                      </VuiTypography>
                    </VuiBox>
                  </VuiBox>
                )}
              </VuiBox>
            )}
          </>
        ) : (
          <>
            <VuiBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
              <VuiTypography variant="button" color="text">
                {txRows.length} total transaction{txRows.length !== 1 ? "s" : ""} in this market
              </VuiTypography>
            </VuiBox>

            {isLoadingTx ? (
              <VuiBox textAlign="center" py={5}>
                <VuiTypography variant="button" color="text">
                  Loading transactions...
                </VuiTypography>
              </VuiBox>
            ) : txRows.length === 0 ? (
              <VuiBox
                textAlign="center"
                py={5}
                sx={{
                  background: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                }}
              >
                <VuiTypography variant="h6" color="text" fontWeight="regular">
                  No transactions yet
                </VuiTypography>
                <VuiTypography variant="caption" color="text" mt={1}>
                  Be the first to deposit in this market
                </VuiTypography>
              </VuiBox>
            ) : (
              <VuiBox
                sx={{
                  "& th": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                        `${borderWidth[1]} solid ${grey[700]}`,
                    },
                  },
                }}
              >
                <Table columns={txColumns} rows={txRows} />
              </VuiBox>
            )}
          </>
        )}
      </VuiBox>
      <VuiBox p={2}>
<Modal
  open={isModalOpen}
  onClose={() => !isLoading && setIsModalOpen(false)}
  aria-labelledby="withdraw-modal-title"
  aria-describedby="withdraw-modal-description"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      maxWidth: '90%',
      bgcolor: 'background.paper',
      background: "rgba(19, 21, 34, 0.95)",
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '15px',
      boxShadow: 24,
      outline: 'none',
    }}
  >
    <VuiBox p={3}>
      <VuiTypography id="withdraw-modal-title" variant="h6" color="white" fontWeight="medium" mb={2}>
        Withdraw {withdrawType === "mother" ? "Mother" : "Child"} Tokens
      </VuiTypography>
      
      <Divider light sx={{ opacity: 0.2, mb: 2 }} />
      
      <VuiTypography variant="body2" color="text" mb={2}>
        Enter the amount you want to withdraw:
      </VuiTypography>

      <VuiInput
        placeholder="Amount"
        value={withdrawAmount}
        onChange={handleAmountChange}
        type="number"
        fullWidth
        disabled={isLoading}
        sx={{
          "& .MuiInputBase-input": {
            color: "white",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 255, 255, 0.3)",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 255, 255, 0.5)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: withdrawType === "mother" ? "#1976d2" : "#2e7d32",
          },
        }}
      />

      {/* <VuiBox display="flex" justifyContent="space-between" alignItems="center" mt={1}>
      <VuiTypography variant="caption" color="text">
      Available:{" "}
      {withdrawType === "mother"
        ? `${parseFloat(
            ethers.utils.formatUnits(
              userMotherBalance?.data?.value || "0",
              userMotherBalance?.data?.decimal || 18
            )
          ).toFixed(2)} ${motherMarket?.baseToken?.symbol}`
        : `${parseFloat(
            ethers.utils.formatUnits(
              userChildBalance?.data?.value || "0",
              userChildBalance?.data?.decimal || 18
            )
          ).toFixed(2)} ${childMarket?.baseToken?.symbol}`}
    </VuiTypography>
        
        <VuiButton 
          color={withdrawType === "mother" ? "info" : "success"}
          size="small"
          onClick={() => setWithdrawAmount((withdrawType === "mother" ? ethers.utils.formatUnits(
            userMotherBalance?.data?.value || "0",
            userMotherBalance?.data?.decimal || 18
          ) : ethers.utils.formatUnits(
            userChildBalance?.data?.value || "0",
            userChildBalance?.data?.decimal || 18
          )))}
          sx={{ minWidth: 'small', py: 0.25, px: 1 }}
        >
          Max
        </VuiButton>
      </VuiBox> */}

      <VuiBox display="flex" justifyContent="space-between" mt={4}>
        <VuiButton 
          color="light" 
          onClick={() => setIsModalOpen(false)} 
          disabled={isLoading}
          sx={{
            opacity: 0.7,
            "&:hover": {
              opacity: 1
            }
          }}
        >
          Cancel
        </VuiButton>

        <VuiButton
          color={withdrawType === "mother" ? "info" : "success"}
          onClick={processWithdrawal}
          disabled={isLoading || !withdrawAmount || parseFloat(withdrawAmount) <= 0 || selectedMarket?.status >0}
          sx={{
            "&:hover": {
              boxShadow: withdrawType === "mother" 
                ? "0 0 10px rgba(33, 82, 255, 0.3)"
                : "0 0 10px rgba(23, 173, 55, 0.3)"
            }
          }}
        >
          {isLoading ? "Processing..." : "Confirm Withdrawal"}
        </VuiButton>
      </VuiBox>
    </VuiBox>
  </Box>
</Modal>
      </VuiBox>
    </Card>
  );
}

export default MarketActivitySection;
